export const polikliniekEmailAddress = 'polikliniek@ksyos.nl';
export const polikliniekPhoneNumber = '020-2366533';
export const serviceDeskEmailAddress = 'info@ksyos.nl';
export const servicedeskPhoneNumber = '020-6000060';
export const serviceDeskPhoneNumberDisplay = '020-600 00 60';
export const digidUrl = 'https://www.digid.nl/';
export const digidFaqUrl = 'https://www.digid.nl/over-digid';

export const smallBreakpoint = 576;
export const mediumBreakpoint = 768;
